export default "__VITE_ASSET__dPYOxbfO__"